/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { PaymentApiConfiguration } from '../payment-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PamInstallmentResponseDto } from '../models/pam-installment-response-dto';


/**
 * the PamQueryInstallment API
 */
@Injectable({
  providedIn: 'root',
})
export class PamQueryInstallmentService extends BaseService {
  constructor(
    config: PaymentApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation installmentFetch
   */
  static readonly InstallmentFetchPath = '/installment/{id}';

  /**
   * Read installment details.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `installmentFetch()` instead.
   *
   * This method doesn't expect any request body.
   */
  installmentFetch$Response(params: {

    /**
     * The installment_uuid can be used to read installment
     */
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PamInstallmentResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, PamQueryInstallmentService.InstallmentFetchPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PamInstallmentResponseDto>;
      })
    );
  }

  /**
   * Read installment details.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `installmentFetch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  installmentFetch(params: {

    /**
     * The installment_uuid can be used to read installment
     */
    id: string;
  },
  context?: HttpContext

): Observable<PamInstallmentResponseDto> {

    return this.installmentFetch$Response(params,context).pipe(
      map((r: StrictHttpResponse<PamInstallmentResponseDto>) => r.body as PamInstallmentResponseDto)
    );
  }

}
